/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesModeratorRoleSchema } from "./moderatorRoleSchema.ts";
import { goodLuckCoreEntitiesTournamentSchema } from "./tournamentSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesTournamentModeratorSchema = z.object({
  id: z.string().nullish(),
  tournamentId: z.string().nullish(),
  userId: z.string().nullish(),
  get role() {
    return goodLuckCoreEntitiesModeratorRoleSchema.optional();
  },
  canManageMatches: z.optional(z.boolean()),
  canManageParticipants: z.optional(z.boolean()),
  canManageBracket: z.optional(z.boolean()),
  canManageSettings: z.optional(z.boolean()),
  canSendAnnouncements: z.optional(z.boolean()),
  canModerateChat: z.optional(z.boolean()),
  canViewRostersOnly: z.optional(z.boolean()),
  roleDisplayName: z.string().max(100).nullish(),
  assignedAt: z.optional(z.iso.datetime()),
  assignedByUserId: z.string().nullish(),
  get tournament() {
    return goodLuckCoreEntitiesTournamentSchema.optional();
  },
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  get assignedByUser() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
});
